import { all, select, call, put, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* patch(action) {
    const { settingId, data } = action.payload;
    try {
        const { organisationSettings } = yield select(
            (state) => state.typesList
        );
        const url = `${config.api.paths.organisationSettings}${settingId}/`;
        /** Update typesList organisationSettings */
        organisationSettings.data.map((item) => {
            if (settingId === item.settingId) item.value = data.value;
        });

        /** update typesList status */
        yield call(http.authorized.patch, url, data);
        yield put(actionCreators.patchSuccess(data));
    } catch (error) {
        logToSentry("On organisation setting patch:", { error });
        yield put(actionCreators.patchFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.ORGANISATION_SETTING_PATCH_REQUEST, patch)
    ]);
}
